import { formatDay, formatFull, formatInstant, formatRelative, formatClock } from "./format";

type Mode = "instant" | "day" | "clock" | "relative";

/**
 * A timestamp, in the reader's timezone, with the exact UTC instant one
 * hover away.
 *
 * A real `<time datetime=…>` element, so the machine-readable value is on
 * the page even though the text is localised.
 */
export function Time({
  value,
  mode = "instant",
  fallback,
}: {
  value: string | null | undefined;
  mode?: Mode;
  fallback?: string;
}) {
  if (!value) return <>{fallback ?? (mode === "relative" ? "never" : "—")}</>;

  const text =
    mode === "relative"
      ? formatRelative(value)
      : mode === "day"
        ? formatDay(value, fallback)
        : mode === "clock"
          ? formatClock(value, fallback)
          : formatInstant(value, fallback);

  return (
    <time dateTime={value} title={formatFull(value)}>
      {text}
    </time>
  );
}
